import { FC } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

interface LoadingFallbackProps {
  message?: string;
}

const LoadingFallback: FC<LoadingFallbackProps> = ({
  message = "Loading...",
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "50vh",
        gap: 2,
      }}
    >
      <CircularProgress size={40} />
      <Typography variant="body2" color="text.secondary">
        {message}
      </Typography>
    </Box>
  );
};

export default LoadingFallback;
